// extracted by mini-css-extract-plugin
export default {"container":"ClientCards_container__8eshv"};